module.exports = __webpack_public_path__ + "img/gaffertape_zwart.43cfeba9.jpg";